import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { requestIdleCallback } from '../utils/idleCallback';
import { loadScript } from '../utils/loadScript';
const LOG = Logger.getLogger('setupTalon');
export const setupTalon = () => {
  try {
    const talonScriptMetaTag = document.querySelector('meta[name="eHawkTalonScript"]'); // We get the bundle location from a meta tag located in the index.html.jade file.

    if (talonScriptMetaTag) {
      // Because the fingerprint calculation is very expensive we do this inside a
      // requestAnimationFrame callback to prevent the main thread to be frozen during
      // the process.
      requestAnimationFrame(() => {
        const src = talonScriptMetaTag.content;
        loadScript(src, 'talon-script').then(() => {
          const talonCallback = window.eHawkTalon;

          if (!talonCallback) {
            LOG.error('Talon callback no found on window object.');
            return;
          }

          requestIdleCallback(() => {
            talonCallback();
          }, {
            timeout: 2000
          });
        }).catch(error => LOG.error('Error loading the talon script.', {
          extra: getSentryExtra(error)
        }));
      });
    }
  } catch (error) {
    LOG.error('Error executing talon script.', {
      extra: getSentryExtra(error)
    });
  }
};